import apiClient from '@/lib/api';
import { Place, PlaceResponse, PlacesResponse } from '@/types/place';

export const placesApi = {
  getAll: (filters = {}): Promise<Place[]> => {
    // Backend returns Place[] directly, axios wraps in { data: Place[] }
    // res.data extracts the array
    return apiClient.get('/api/places', { params: filters }).then(res => res.data);
  },
  
  getById: (id: string): Promise<Place> => {
    return apiClient.get(`/api/places/${id}`).then(res => res.data);
  },
  
  create: (data: Partial<Place>): Promise<Place> => {
    return apiClient.post('/api/places', data).then(res => res.data);
  },
  
  update: (id: string, data: Partial<Place>): Promise<Place> => {
    return apiClient.put(`/api/places/${id}`, data).then(res => res.data);
  },
  
  delete: (id: string): Promise<void> => {
    return apiClient.delete(`/api/places/${id}`).then(() => undefined);
  },
};
